import i18n from '@/i18n';
import Quill from 'quill';
import { CSS_WEEK_OVERVIEW_TABLE, DATA_WEEK_OVERVIEW, redistributeColumnWidths } from '@/support/quill-table-toolbar/types';
export function addTableModule(editor) {
    const toolbar = editor.getModule('toolbar');
    if (toolbar) {
        toolbar.addHandler('table', () => {
            const tableModule = editor.getModule('better-table');
            if (tableModule) {
                const tableRows = 2; // Default number of rows
                const tableColumns = 2; // Default number of columns
                tableModule.insertTable(tableRows, tableColumns);
                fixRegularTableWidths(editor);
            }
            else {
                console.error('Table module not found');
            }
        });
    }
    else {
        console.error('Toolbar module not found');
    }
}
export function registerCustomButtons(editor, customActions) {
    const toolbar = editor.getModule('toolbar');
    if (toolbar) {
        customActions.forEach((action) => {
            const button = toolbar.container.querySelector(`.ql-${action.name}`);
            if (button) {
                setupCustomButton(button, action, editor);
            }
            else {
                console.error(`Button for action "${action.name}" not found in toolbar`);
            }
        });
    }
    else {
        console.error('Toolbar module not found');
    }
}
function setupCustomButton(button, action, editor) {
    button.innerHTML = `<span class="ql-custom-icon">${action.icon}</span>`;
    button.type = 'button';
    button.title = action.tooltip || action.name;
    button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        action.handler(editor, action.data, event);
    });
}
export function getCurrentInsertionIndex(editor) {
    const range = editor.getSelection();
    return range ? range.index : editor.getLength();
}
export function populateWeekOverviewTable(editor, insertionIndex) {
    const targetTable = findTargetTable(editor, insertionIndex);
    if (targetTable) {
        targetTable.setAttribute(DATA_WEEK_OVERVIEW, 'true');
        targetTable.classList.add(CSS_WEEK_OVERVIEW_TABLE);
        fixWeekOverviewTableStyles(editor, targetTable, insertionIndex);
        // Prevent context menu on the week overview to avoid default actions
        targetTable.addEventListener('contextmenu', (event) => {
            event.preventDefault();
            event.stopPropagation();
        });
        fillWeekOverviewWithWeekDays(editor, targetTable);
    }
    else {
        console.error('Target table not found for insertion');
    }
}
function findTargetTable(editor, insertionIndex) {
    const allTables = editor.root.parentNode.querySelectorAll('table');
    for (let i = allTables.length - 1; i >= 0; i--) {
        const table = allTables[i];
        const tableBlot = Quill.find(table);
        if (tableBlot) {
            const tableIndex = editor.getIndex(tableBlot);
            if (tableIndex >= insertionIndex) {
                return table;
            }
        }
        else {
            console.error('Table blot not found for the given table element');
        }
    }
    return null;
}
function fillWeekOverviewWithWeekDays(editor, table) {
    const firstColumnCells = table.querySelectorAll('td:first-child, th:first-child');
    const weekdays = [i18n.tc('Monday'), i18n.tc('Tuesday'), i18n.tc('Wednesday'), i18n.tc('Thursday'), i18n.tc('Friday')];
    firstColumnCells.forEach((cell, index) => {
        if (index < weekdays.length) {
            insertTextIntoCell(editor, cell, weekdays[index]);
        }
    });
}
function insertTextIntoCell(editor, cell, text) {
    const cellBlot = Quill.find(cell);
    if (cellBlot) {
        const cellIndex = editor.getIndex(cellBlot);
        editor.insertText(cellIndex, text);
    }
    else {
        console.error('Cell blot not found for the given cell element');
    }
}
function fixRegularTableWidths(editor) {
    const tables = editor.root.querySelectorAll(`table.quill-better-table:not(.${CSS_WEEK_OVERVIEW_TABLE})`);
    tables.forEach((table) => {
        redistributeColumnWidths(editor, table);
    });
}
function fixWeekOverviewTableStyles(editor, table, insertionIndex) {
    const cols = table.querySelectorAll('colgroup col');
    cols.forEach((col, index) => {
        col.removeAttribute('width');
        if (index === 0) {
            col.setAttribute('width', '130');
            col.setAttribute('style', 'width:130px;min-width:130px;max-width:130px;');
        }
        else {
            col.setAttribute('width', '');
            col.setAttribute('style', 'width:auto;');
        }
    });
    const firstCells = table.querySelectorAll('th:first-child, td:first-child');
    firstCells.forEach((cell) => {
        cell.setAttribute('width', '130');
        cell.setAttribute('style', 'width:130px;min-width:130px;max-width:130px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;');
    });
}
